import React, { useContext, useEffect, useState } from "react";
import { apiGet, apiDelete } from "../../../utils/apiFetch";
import apiPath from "../../../utils/apiPath";
import OButton from "components/reusable/OButton";
import ODateRangePicker from "components/shared/datePicker/ODateRangePicker";
import dayjs from "dayjs";
import Pagination from "../../Pagination";
import AuthContext from "context/AuthContext";
import { useTranslation } from "react-i18next";
import FinalEmployeeTable from "./FinalEmployeeTable";
import EmployeeView from "./EmployeeView";
import helpers from "../../../utils/helpers";
import OSearch from "components/reusable/OSearch";
import CustomSelect from "components/reusable/CustomSelect";
import { employeeOptions } from "utils/constants";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";

const FinalEmployeeList = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10,
  });
  const { updatePageName } = useContext(AuthContext);
  const [employeeList, setEmployeeList] = useState([]);
  const [currentItem, setCurrentItem] = useState("");
  const [employeeView, setEmployeeView] = useState(false);
  const [filterData, setFilterData] = useState({
    startDate: "",
    endDate: "",
    category: "",
    searchKey: "",
    isFilter: false,
    isReset: false,
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [isInitialized, setIsInitialized] = useState(false);
  const [sort, setSort] = useState({
    sortBy: "createdAt",
    sortType: "desc",
  });

  const handleView = (item) => {
    setCurrentItem(item);
    setEmployeeView(!employeeView);
  };

  const handlePageClick = (event) => {
    const newPage = event.selected + 1;
    setPage(newPage);
  };

  const allEmployeeList = async (data) => {
    try {
      const { searchKey, isFilter, category, startDate, endDate } = filterData;
      if (
        (data?.deletePage && employeeList?.length >= 1) ||
        (isFilter &&
          category &&
          data?.statusChange &&
          employeeList?.length >= 1)
      ) {
        setPage(page - 1);
        setPaginationObj({ ...paginationObj, page: page - 1 });
      }

      const payload = {
        status: category,
        page,
        pageSize,
        startDate: helpers?.ternaryCondition(
          startDate,
          dayjs(startDate).format("YYYY-MM-DD"),
          null
        ),
        endDate: helpers?.ternaryCondition(
          endDate,
          dayjs(endDate).format("YYYY-MM-DD"),
          null
        ),
        keyword: searchKey?.trim(),
        sortBy: sort.sortBy,
        sortType: sort.sortType,
      };
      const path = apiPath.finalEmployeeList;
      const result = await apiGet(path, payload);
      const response = result?.data?.results;
      const resultStatus = result?.data?.success;
      setEmployeeList(response?.docs);
      setPaginationObj({
        ...paginationObj,
        page: helpers?.ternaryCondition(resultStatus, response.page, null),
        pageCount: helpers?.ternaryCondition(
          resultStatus,
          response.totalPages,
          null
        ),
        perPageItem: helpers?.ternaryCondition(
          resultStatus,
          response?.docs.length,
          null
        ),
        totalItems: helpers?.ternaryCondition(
          resultStatus,
          response.totalDocs,
          null
        ),
      });
    } catch (error) {
      console.log("error in get all employee list==>>>>", error.message);
    }
  };

  useEffect(() => {
    allEmployeeList();
  }, [page, filterData, sort]);

  const handleReset = () => {
    setFilterData({
      searchKey: "",
      startDate: "",
      category: "",
      endDate: "",
      isReset: true,
      isFilter: false,
    });
    setPage(1);
    setSearchTerm("");
  };

  useEffect(() => {
    helpers.setDebouncingFunction({
      isInitialized,
      setIsInitialized,
      debouncedSearchTerm,
      searchTerm,
      filterData,
      setFilterData,
      setPage,
    });
  }, [debouncedSearchTerm]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [searchTerm]);

  useEffect(() => {
    updatePageName(t("NAV_JOB_REQUEST_MGMT"));
  }, []);

  const handleDateChange = (start, end) => {
    setPage(1);
    setFilterData({
      ...filterData,
      startDate: start,
      endDate: end,
      isFilter: true,
    });
  };

  const statusPage = (e) => {
    setFilterData({ ...filterData, category: e.target.value, isFilter: true });
    setPage(1);
  };

  useEffect(() => {
    if (location.state)
      setFilterData({ ...filterData, category: location.state });
  }, [location.state]);

  // ---------------------- DELETE HANDLER ----------------------
  const handleDelete = async (item) => {
    const confirm = await Swal.fire({
      title: t("O_DELETE_WARNING"),
      text: t("O_ARE_YOU_SURE"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: t("O_YES_DELETE"),
      cancelButtonText: t("O_CANCEL"),
    });

    if (!confirm.isConfirmed) return;

    try {
      const path = apiPath.deleteJobRequest;
      const result = await apiDelete(`${path}/${item._id}`);
      const isSuccess = result?.data?.success;

      if (isSuccess) {
        Swal.fire({
          icon: "success",
          title: t("DELETED_SUCCESSFULLY"),
          timer: 1500,
          showConfirmButton: false,
        });
        allEmployeeList({ deletePage: true });
      } else {
        Swal.fire({
          icon: "error",
          title: t("SOMETHING_WENT_WRONG"),
          timer: 1500,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.log("error in delete job request ==>", error.message);
      Swal.fire({
        icon: "error",
        title: error.message || t("SOMETHING_WENT_WRONG"),
      });
    }
  };
  // ------------------------------------------------------------

  return (
    <>
      {" "}
      <div className="bg-[#F9F9F9]">
        <div className="py-4 px-3">
          <div className="bg-white border rounded-lg border-[#E9EDF9]">
            <form className="border-b border-b-[#E3E3E3] gap-2 2xl:flex px-4 py-3">
              <div className="col-span-2 flex flex-wrap  items-center mb-2 2xl:mb-0">
                <div className="flex items-center flex-wrap lg:pt-0 pt-3">
                  <div className="relative flex mb-3 items-center">
                    <OSearch
                      placeholder={t("SEARCH_BY_EMPLOYEE_NAME_EMAIL")}
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                    />
                  </div>
                  <ODateRangePicker
                    handleDateChange={handleDateChange}
                    setIsReset={setFilterData}
                    isReset={filterData?.isReset}
                  />
                  <CustomSelect
                    id="category"
                    name="category"
                    options={employeeOptions}
                    placeholder="O_ALL"
                    value={filterData.category}
                    onChange={statusPage}
                    t={t}
                  />

                  <OButton
                    label="Reset"
                    extraClasses="ml-3 mb-3"
                    style={{ borderRadius: "0.5rem" }}
                    type="button"
                    onClick={handleReset}
                  />
                </div>
              </div>
            </form>
            {employeeView && (
              <EmployeeView
                employeeView={employeeView}
                setEmployeeView={setEmployeeView}
                currentItem={currentItem}
                handleView={handleView}
              />
            )}
            <FinalEmployeeTable
              handleView={handleView}
              handleDelete={handleDelete}
              currentItem={currentItem}
              employeeView={employeeView}
              setSort={setSort}
              sort={sort}
              employeeList={employeeList}
              allEmployeeList={allEmployeeList}
              page={page}
            />
            {paginationObj?.totalItems ? (
              <Pagination
                page={page}
                handlePageClick={handlePageClick}
                options={paginationObj}
              />
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default FinalEmployeeList;